import {DataTable} from "primereact/datatable";
import {Column} from "primereact/column";
import {Paginator} from "primereact/paginator";
import React, {useRef} from "react";
import PropTypes from "prop-types";
import {Link} from "react-router-dom";
import {Button} from "primereact/button";

const UserTable = ({page, pageSize, onPageChange, data, totalItems}) => {
    const legalTable = useRef();

    const createTimeBodyTemplate = (rowData) => {
        const { createdTimestamp } = rowData;
        const fromSecondsToDate = (seconds) => {
            return new Date(seconds).toLocaleString().split(",")[0];
        };
        const date = fromSecondsToDate(createdTimestamp);

        return (
            <div>
                <span>{date}</span>
            </div>
        );
    };

    const linkBodyTemplate = (rowData) => {
        return (
            <div>
                <Link to={`/user/${rowData.id}`} className="order__link">
                    {rowData.id}
                </Link>
                <Button
                    onClick={() => navigator.clipboard.writeText(rowData.id)}
                    className="p-button-secondary p-button-text"
                >
                    <i className="pi pi-copy" style={{ paddingLeft: "2px" }} />
                </Button>
            </div>
        );
    };
    return <div className="card">
        <DataTable
            ref={legalTable}
            value={data}
            className="p-datatable-customers"
            dataKey="id"
            rowHover
            emptyMessage="Данные не найдены"
            scrollable
        >
            {/*<Column body={actionBodyTemplate} headerStyle={{width: '8em', textAlign: 'center'}} bodyStyle={{textAlign: 'center', overflow: 'visible'}} />*/}
            <Column
                headerStyle={{ width: "200px" }}
                columnKey="id"
                field="id"
                header="ID"
                body={linkBodyTemplate}
                sortable
            />
            <Column
                headerStyle={{ width: "200px" }}
                columnKey="lastName"
                field="lastName"
                header="Фамилия"
                sortable
            />
            <Column
                headerStyle={{ width: "200px" }}
                columnKey="firstName"
                field="firstName"
                header="Имя"
                sortable
            />
            <Column
                headerStyle={{ width: "200px" }}
                columnKey="username"
                field="username"
                header="Номер телефона"
                sortable
            />
            <Column
                headerStyle={{ width: "200px" }}
                columnKey="bin"
                field="bin"
                header="БИН"
                sortable
            />
            <Column
                headerStyle={{ width: "200px" }}
                columnKey="companyName"
                field="companyName"
                header="Наименование компании"
                sortable
            />
            <Column
                headerStyle={{ width: "200px" }}
                columnKey="createdTimestamp"
                field="createdTimestamp"
                header="Дата регистрации"
                body={createTimeBodyTemplate}
                sortable
            />
        </DataTable>
        <Paginator
            currentPageReportTemplate="Показано с {first} по {last} из {totalRecords} записей"
            template="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
            first={page * pageSize}
            rows={pageSize}
            totalRecords={totalItems}
            rowsPerPageOptions={[10, 25, 50, "все"]}
            onPageChange={onPageChange}
        />
    </div>
}

UserTable.propTypes = {
    page: PropTypes.number.isRequired,
    pageSize: PropTypes.number.isRequired,
    onPageChange: PropTypes.func.isRequired,
    data: PropTypes.array.isRequired,
    totalItems: PropTypes.number.isRequired,
}

export default UserTable;